import TourAdmin from '../../components/TourAdmin/main.iife';

export default class extends window.Controller {
    static get targets() {
        return ['name'];
    }

    connect() {
        this.init();
    }

    init() {
        const el = this.element;

        if (window.TourAdmin && el) {
            window.TourAdmin.init(el);
        }
    }
}
